/** Display label for a claim/policy type. */
export function getClaimTypeLabel(raw?: string | null): string {
  const type = String(raw || "").trim().toLowerCase();

  if (type.includes("shipping")) return "Shipping";
  if (type.includes("extended")) return "Extended Warranty";
  if (type.includes("manufacturing")) return "Manufacturing";
  if (type.includes("accidental") || type === "protection") {
    return "Accidental Protection";
  }

  return "Accidental Protection";
}

export function isShippingClaimType(raw?: string | null): boolean {
  return String(raw || "").toLowerCase().includes("shipping");
}
